import script from "./RegisterPhone.vue?vue&type=script&setup=true&lang=js"
export * from "./RegisterPhone.vue?vue&type=script&setup=true&lang=js"

import "./RegisterPhone.vue?vue&type=style&index=0&id=540fb83d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-540fb83d"]])

export default __exports__